// Client-side deterrents against casual inspection.
// NOTE: This is defense-in-depth, not real security. A determined attacker
// with a proxy or a patched browser can always read client code.

let installed = false;

export function installSecurityGuard() {
  if (installed || typeof window === "undefined") return;
  installed = true;

  const isProd = window.location.hostname !== "localhost" && !window.location.hostname.startsWith("127.");

  // 1. Block right-click context menu
  window.addEventListener("contextmenu", (e) => {
    e.preventDefault();
    return false;
  });

  // 2. Block common devtools / view-source keyboard shortcuts
  window.addEventListener("keydown", (e) => {
    const k = (e.key || "").toLowerCase();
    // F12
    if (e.key === "F12") { e.preventDefault(); return false; }
    // Ctrl+U (view source)
    if ((e.ctrlKey || e.metaKey) && k === "u") { e.preventDefault(); return false; }
    // Ctrl+S (save page)
    if ((e.ctrlKey || e.metaKey) && k === "s") { e.preventDefault(); return false; }
    // Ctrl+Shift+I / J / C / K (devtools variants)
    if ((e.ctrlKey || e.metaKey) && e.shiftKey && ["i", "j", "c", "k"].includes(k)) {
      e.preventDefault();
      return false;
    }
  });

  // 3. Block drag & text selection of sensitive areas (leave inputs alone)
  window.addEventListener("dragstart", (e) => {
    const t = e.target;
    if (t && (t.tagName === "IMG" || t.tagName === "A")) e.preventDefault();
  });

  // 4. Silence console output in production so leaked errors don't reveal stack traces
  if (isProd) {
    try {
      const noop = () => {};
      ["log", "info", "debug", "warn", "error", "table", "trace", "group", "groupEnd", "dir"].forEach((m) => {
        // eslint-disable-next-line no-console
        console[m] = noop;
      });
      // Wipe any pre-existing devtools hook so React tree isn't inspectable
      if (window.__REACT_DEVTOOLS_GLOBAL_HOOK__) {
        try {
          Object.keys(window.__REACT_DEVTOOLS_GLOBAL_HOOK__).forEach((k) => {
            window.__REACT_DEVTOOLS_GLOBAL_HOOK__[k] = () => {};
          });
        } catch { /* ignore */ }
      }
    } catch { /* ignore */ }
  }

  // 5. DevTools open detector — size-delta heuristic
  //    Docked devtools shrink innerWidth/innerHeight vs outer*. When detected,
  //    blur the app and show an overlay so page content isn't readable.
  const guardOverlayId = "__sec_lock_overlay__";
  const showLock = () => {
    if (document.getElementById(guardOverlayId)) return;
    const div = document.createElement("div");
    div.id = guardOverlayId;
    div.setAttribute("style", [
      "position:fixed", "inset:0", "z-index:2147483647",
      "background:#0b1a14", "color:#e8dfcb",
      "display:flex", "align-items:center", "justify-content:center",
      "font-family:system-ui,-apple-system,sans-serif", "font-size:14px",
      "letter-spacing:0.04em", "text-align:center", "padding:2rem",
    ].join(";"));
    div.textContent = "This application is not available for inspection. Please close developer tools to continue.";
    document.body.appendChild(div);
    try { document.body.style.pointerEvents = "none"; } catch { /* ignore */ }
  };
  const hideLock = () => {
    const el = document.getElementById(guardOverlayId);
    if (el) el.remove();
    try { document.body.style.pointerEvents = ""; } catch { /* ignore */ }
  };

  const detect = () => {
    if (!isProd) return; // don't harass developers on localhost
    const threshold = 160;
    const wDiff = window.outerWidth - window.innerWidth;
    const hDiff = window.outerHeight - window.innerHeight;
    const open = wDiff > threshold || hDiff > threshold;
    if (open) showLock(); else hideLock();
  };

  setInterval(detect, 1000);
  window.addEventListener("resize", detect);

  // 6. Neuter the `debugger` timing-attack detector (some sites use it to
  //    freeze devtools). We keep it lightweight so it doesn't burn CPU.
  if (isProd) {
    setInterval(() => {
      const start = performance.now();
      // eslint-disable-next-line no-debugger
      debugger;
      const elapsed = performance.now() - start;
      if (elapsed > 100) showLock();
    }, 2000);
  }
}
